import Vue from 'vue'
import Router from 'vue-router'
import NewEnergyDetail from '@/view/NewEnergyDetail.vue';
import heavyTruck from '@/view/heavyTruck.vue';
import lightTruck from '@/view/lightTruck.vue';
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '商用车金融服务'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '金融服务'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '购车服务'
              }
            },
            {
              path: '/software/salesService',
              name: 'software',
              component: resolve => require(['@/view/Software_salesService'], resolve),
              meta: {
                title: '售后服务'
              }
            }
          ]
        // }, {
        //   path: '/service',
        //   name: 'service',
        //   component: resolve => require(['@/view/Service'], resolve),
        //   meta: {
        //     title: '相关服务'
        //   }
        },
        {
          path: '/detail/:id', // 动态路由参数
          name: 'NewEnergyDetail',
          component: NewEnergyDetail
        } ,
        {
          path: '/heavyDetail/:id', // 动态路由参数
          name: 'heavyTruck',
          component: heavyTruck
        },
        {
          path: '/lightDetail/:id', // 动态路由参数
          name: 'lightTruck',
          component: lightTruck
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        },
        , {
          path: '/new-energy',
          name: 'new-energy',
          component: resolve => require(['@/view/new-energy'], resolve),
          meta: {
            title: '新能源车型'
          }
        },
        , {
          path: '/light-truck',
          name: 'light-truck',
          component: resolve => require(['@/view/light-truck'], resolve),
          meta: {
            title: '轻卡车型'
          }
        },
        , {
          path: '/heavy-truck',
          name: 'heavy-truck',
          component: resolve => require(['@/view/heavy-truck'], resolve),
          meta: {
            title: '中重卡车型'
          }
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js